import { Expression, ExpressionArg } from "survey-engine/data_types";

export const autoMessageTypes = ['all-users', 'study-participants'] as const;

export const TemplateTypeWeekly = 'weekly';
export const TemplateTypeStudyReminder = "study-reminder";
export const TemplateTypeNewsletter = "newsletter";

export const templateMessageTypes = [TemplateTypeWeekly, TemplateTypeNewsletter, TemplateTypeStudyReminder];

export type AutoMessageType = typeof autoMessageTypes[number];

// Message template
export interface MessageTemplate {
    id?: string;
    messageType: string;
    studyKey?: string;
    defaultLanguage: string;
    translations: MessageTranslation[];
}

export interface StoredMessageTemplate extends MessageTemplate {
    collection: string;
    created_at?: string;
    internal_name?: string;
}

// Translation of a message template
export interface MessageTranslation {
    lang: string;
    templateDef: string;
    subject: string;
}

export type SystemTemplatesResponse = {
    templates: MessageTemplate[];
}

export type StoredTemplatesResponse = {
    templates: StoredMessageTemplate[]
}

export type DayName = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

export interface NextTimeDefinition {
    day?: DayName;
    hour?: number;
    minute?: number;
}

export interface NextTimeRecipe {
  next: NextTimeDefinition;
}

/**
 * Relative time expression by duration
 */
export interface InTimeRecipe {
  in: Duration;
}

export type TimeExpression = NextTimeRecipe | InTimeRecipe;

/**
 * TimeRecipe is a fixed timestamp or a relative time definition like next monday at 14:00 on In 2 minutes
 */
export type TimeRecipe = number | TimeExpression;

export const isNextTimeRecipe = (e: TimeRecipe): e is NextTimeRecipe =>{
    return typeof(e) == "object" && 'next' in e;
}

export const isInTimeRecipe = (e: TimeRecipe): e is InTimeRecipe =>{
    return typeof(e) == "object" && 'in' in e;
}

export const isTimeExpression = (e: TimeRecipe): e is TimeExpression =>{
    return typeof(e) == "object" && ('in' in e  || 'next' in e );
}


export interface AutoMessage {
  id?: string;
  template: MessageTemplate;
  type: AutoMessageType; // all-users - study-participants
  studyKey?: string;
  condition?:ExpressionArg;
  nextTime: TimeRecipe; // when is the next time the message should be triggered
  until?: TimeRecipe; // When automessage should stop to be sent
  period: number;    // how often it should be triggered
  label?: string;
}

export interface AutoMessagesListResponse {
    autoMessages: AutoMessage[];
} 

export interface AutoMessageInstallResponse {
    automessage?: AutoMessage;
    errors?: string[]
}

export type CustomMessagesResponse = Array<CustomMessage>;

export interface CustomMessage {
    id?: number;
    template: MessageTemplate;
    label: string;
    condition?: Expression;
}

export const createEmptyCustomMessage = ():CustomMessage =>{
    return {
        label: '',
        template: {
            messageType: '',
            translations: [],
            defaultLanguage: ''
        }
    };
}

export const createEmptyMessageTemplate = ():MessageTemplate =>{
    return {
        messageType: '',
        translations: [],
        defaultLanguage: '',
    };
}

export const createEmptyStoredMessageTemplate = (collection:string):StoredMessageTemplate =>{
    return {
        collection: collection,
        messageType: '',
        translations: [],
        defaultLanguage: '',
    };
}

export interface MessageCondition {
    id?: number;
    label: string;
    condition: Expression;
}

export interface Preview {
    content: string;
    errors?: string[]
}

export type MessageConditionsResponse = Array<MessageCondition>;